import * as React from "react"
import { useTranslation } from "react-i18next"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import FoldableList from "shared/components/FoldableList"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IOptionList } from "shared/hubrise/models"
import * as OptionList from "shared/hubrise/utils/OptionList"
import * as Sku from "shared/hubrise/utils/Sku"

import { Label, SkuLink, StyledUsage } from "./Styles"

const Usage = ({ optionList }: { optionList: IOptionList }): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()

  const { catalog } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  return (
    <StyledUsage>
      <Label>{t("option_list.usage.title")}</Label>
      <FoldableList items={OptionList.findUsages(catalog, optionList)} nbItemsToShow={10}>
        {({ product, sku }) => (
          <SkuLink onClick={() => navigate(catalogNavigation.editPath("product", product.id))}>
            {Sku.fullName(product, sku)}
          </SkuLink>
        )}
      </FoldableList>
    </StyledUsage>
  )
}

export default Usage
